import { createTheme, rem } from '@mantine/core';

/**
 * Создать тему Mantine с выбранным акцентным цветом
 */
export function buildTheme(primaryColor: string = 'blue') {
  return createTheme({
    primaryColor,
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
    fontFamilyMonospace: '"JetBrains Mono", monospace',
    headings: {
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
      fontWeight: '600',
      sizes: {
        h1: { fontSize: rem(28), lineHeight: '1.3' },
        h2: { fontSize: rem(22), lineHeight: '1.35' },
        h3: { fontSize: rem(18), lineHeight: '1.4' },
        h4: { fontSize: rem(16), lineHeight: '1.45' },
      },
    },
    fontSizes: { xs: rem(11), sm: rem(12), md: rem(14), lg: rem(16), xl: rem(18) },
    spacing: { xs: rem(4), sm: rem(8), md: rem(16), lg: rem(24), xl: rem(32) },
    radius: { xs: rem(2), sm: rem(4), md: rem(8), lg: rem(12), xl: rem(16) },
    shadows: {
      xs: '0 1px 2px rgba(0,0,0,0.05)',
      sm: '0 1px 3px rgba(0,0,0,0.1)',
      md: '0 4px 8px rgba(0,0,0,0.12)',
      lg: '0 8px 16px rgba(0,0,0,0.15)',
      xl: '0 16px 32px rgba(0,0,0,0.2)',
    },
    breakpoints: { xs: '480px', sm: '768px', md: '1024px', lg: '1280px', xl: '1536px' },
    defaultRadius: 'md',
    components: {
      Button: { defaultProps: { size: 'md', radius: 'md' } },
      TextInput: { defaultProps: { size: 'sm', radius: 'md' } },
      PasswordInput: { defaultProps: { size: 'sm', radius: 'md' } },
      Select: { defaultProps: { size: 'sm', searchable: true, radius: 'md' } },
      NumberInput: { defaultProps: { size: 'sm', radius: 'md' } },
      Textarea: { defaultProps: { size: 'sm', radius: 'md' } },
      Modal: { defaultProps: { centered: true, overlayProps: { blur: 3, opacity: 0.4 }, radius: 'lg' } },
      Notification: { defaultProps: { radius: 'lg' } },
      Badge: { defaultProps: { variant: 'light', size: 'sm', radius: 'md' } },
      Tooltip: { defaultProps: { withArrow: true, openDelay: 300, radius: 'md' } },
      Table: { defaultProps: { striped: true, highlightOnHover: true, withTableBorder: true } },
      Paper: { defaultProps: { radius: 'lg', shadow: 'sm' } },
      Card: { defaultProps: { radius: 'lg', shadow: 'sm' } },
      Alert: { defaultProps: { radius: 'lg' } },
      Tabs: { defaultProps: { radius: 'md' } },
    },
  });
}

/** Дефолтная тема (для обратной совместимости) */
export const theme = buildTheme('blue');

/** Палитра доступных акцентных цветов */
export const ACCENT_COLORS = [
  'blue', 'cyan', 'teal', 'green', 'lime',
  'yellow', 'orange', 'red', 'pink', 'grape',
  'violet', 'indigo',
] as const;
